var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm.hasExistingLeases()
        ? [
            _c("h4", { staticClass: "headingLevel mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.getTranslation(
                    "licence-configurator",
                    "subscription_options"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _vm.hasNewPrograms()
              ? [
                  _c(
                    "b-form-radio",
                    {
                      staticClass: "mb-3 ml-5",
                      attrs: {
                        id: "lease_custom_" + _vm.product.id,
                        name: "configure_period_" + _vm.product.id,
                        value: "1",
                      },
                      model: {
                        value: _vm.leaseOptions.selectedOption,
                        callback: function ($$v) {
                          _vm.$set(_vm.leaseOptions, "selectedOption", $$v)
                        },
                        expression: "leaseOptions.selectedOption",
                      },
                    },
                    [
                      _c("span", { staticClass: "font-weight-medium" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getTranslation(
                              "licence-configurator",
                              "attach_to_existing_subscription"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-5" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ml-5",
                        class:
                          _vm.leaseOptions.selectedOption != 1 ? "d-none" : "",
                      },
                      _vm._l(
                        _vm.leaseUniqueDates[_vm.product.id],
                        function (date) {
                          return _c(
                            "b-form-radio",
                            {
                              key: date,
                              staticClass: "mb-3",
                              attrs: {
                                id:
                                  "mergeNewSoftwareExistingLease_" +
                                  date +
                                  _vm.product.id,
                                name:
                                  "mergeNewSoftwareExistingLease_" +
                                  _vm.product.id,
                                value: date,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.setMergeSingle($event)
                                },
                              },
                              model: {
                                value: _vm.leaseOptions.selectedDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.leaseOptions,
                                    "selectedDate",
                                    $$v
                                  )
                                },
                                expression: "leaseOptions.selectedDate",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "500" } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "400" } },
                                    [_vm._v(_vm._s(_vm.formatDateByLang(date)))]
                                  ),
                                  _vm._v(
                                    " - " +
                                      _vm._s(_vm.getProgramText(date)) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ]),
                ]
              : [
                  _c(
                    "b-form-radio",
                    {
                      staticClass: "mb-3 ml-5",
                      attrs: {
                        id: "lease_custom_" + _vm.product.id,
                        name: "configure_period_" + _vm.product.id,
                        value: "4",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.prolongOneYear()
                        },
                      },
                      model: {
                        value: _vm.leaseOptions.selectedOption,
                        callback: function ($$v) {
                          _vm.$set(_vm.leaseOptions, "selectedOption", $$v)
                        },
                        expression: "leaseOptions.selectedOption",
                      },
                    },
                    [
                      _c("span", { staticClass: "font-weight-medium" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getTranslation(
                              "licence-configurator",
                              "prolong_selected_subscription_by_one_year"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-5" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ml-5",
                        class:
                          _vm.leaseOptions.selectedOption != 4 ? "d-none" : "",
                      },
                      _vm._l(
                        _vm.leaseUniqueDates[_vm.product.id],
                        function (date) {
                          return _c(
                            "div",
                            {
                              key: date,
                              staticClass:
                                "custom-control custom-checkbox b-custom-control-lg mb-4",
                            },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id:
                                    "mergeNewSoftwareExistingLease_" +
                                    _vm.product.id +
                                    date,
                                  name:
                                    "mergeNewSoftwareExistingLease_" +
                                    _vm.product.id +
                                    date,
                                },
                                domProps: {
                                  value: date,
                                  checked:
                                    _vm.leaseOptions.dates &&
                                    _vm.leaseOptions.dates.includes(date) &&
                                    _vm.leaseOptions.selectedOption == 4,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.prolongOneYear(date)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "custom-control-label d-flex flex-wrap",
                                  staticStyle: { "font-size": "16px" },
                                  attrs: {
                                    for:
                                      "mergeNewSoftwareExistingLease_" +
                                      _vm.product.id +
                                      date,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "400" } },
                                    [_vm._v(_vm._s(_vm.formatDateByLang(date)))]
                                  ),
                                  _vm._v(
                                    " - " +
                                      _vm._s(_vm.getProgramText(date)) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ],
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-5" },
              [
                Object.keys(_vm.leaseUniqueDates[_vm.product.id]).length > 1
                  ? [
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mb-3 mt-4",
                          attrs: {
                            id: "lease_merge_" + _vm.product.id,
                            name: "configure_period_" + _vm.product.id,
                            value: "2",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.addLeaseMerge(false)
                            },
                          },
                          model: {
                            value: _vm.leaseOptions.selectedOption,
                            callback: function ($$v) {
                              _vm.$set(_vm.leaseOptions, "selectedOption", $$v)
                            },
                            expression: "leaseOptions.selectedOption",
                          },
                        },
                        [
                          _vm.hasNewPrograms()
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-medium mb-4" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTranslation(
                                          "licence-configurator",
                                          "merge_new_license_and_existing_subscriptions"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-medium mb-4" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTranslation(
                                          "licence-configurator",
                                          "merge_subscriptions"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.leaseUniqueDates[_vm.product.id],
                        function (date) {
                          return _c(
                            "div",
                            {
                              key: date,
                              staticClass:
                                "custom-control custom-checkbox b-custom-control-lg mb-4 ml-5",
                              class:
                                _vm.leaseOptions.selectedOption != 2
                                  ? "d-none"
                                  : "",
                            },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id:
                                    "lease_merge_" +
                                    _vm.product.id +
                                    "_" +
                                    date,
                                  name:
                                    "lease_merge_" +
                                    _vm.product.id +
                                    "_" +
                                    date,
                                  disabled: true,
                                  onclick: "return false;",
                                },
                                domProps: {
                                  value: date,
                                  checked:
                                    _vm.leaseOptions.dates &&
                                    _vm.leaseOptions.dates.includes(date) &&
                                    _vm.leaseOptions.selectedOption == 2,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "custom-control-label d-flex flex-wrap",
                                  staticStyle: { "font-size": "16px" },
                                  attrs: {
                                    for:
                                      "lease_merge_" +
                                      _vm.product.id +
                                      "_" +
                                      date,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "400" } },
                                    [_vm._v(_vm._s(_vm.formatDateByLang(date)))]
                                  ),
                                  _vm._v(
                                    " - " +
                                      _vm._s(_vm.getProgramText(date)) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasExistingLeases()
        ? [
            _c("h4", { staticClass: "headingLevel mb-4 " }, [
              _vm._v(
                _vm._s(
                  _vm.getTranslation(
                    "licence-configurator",
                    "new_subscription_renewal_date"
                  )
                )
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNewPrograms()
        ? [
            _c(
              "b-form-radio",
              {
                staticClass: "mb-3 mt-4 ml-5",
                attrs: {
                  id: "lease_oneYear_" + _vm.product.id,
                  name: "configure_period_" + _vm.product.id,
                  value: "3",
                },
                model: {
                  value: _vm.leaseOptions.selectedOption,
                  callback: function ($$v) {
                    _vm.$set(_vm.leaseOptions, "selectedOption", $$v)
                  },
                  expression: "leaseOptions.selectedOption",
                },
              },
              [
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getTranslation(
                        "licence-configurator",
                        "create_new_subscription_one_year"
                      )
                    )
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "headingLevel mb-4 mt-5" }, [
        _c("div", { staticClass: "custom-control custom-checkbox mb-1" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.leaseOptions.showDatePicker,
                expression: "leaseOptions.showDatePicker",
              },
            ],
            staticClass: "custom-control-input",
            attrs: { type: "checkbox", id: "show_date_" + _vm.product.id },
            domProps: {
              checked: Array.isArray(_vm.leaseOptions.showDatePicker)
                ? _vm._i(_vm.leaseOptions.showDatePicker, null) > -1
                : _vm.leaseOptions.showDatePicker,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.leaseOptions.showDatePicker,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.leaseOptions,
                          "showDatePicker",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.leaseOptions,
                          "showDatePicker",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.leaseOptions, "showDatePicker", $$c)
                  }
                },
                function ($event) {
                  return _vm.updateLeaseDatePicker($event)
                },
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom-control-label d-flex flex-wrap",
              staticStyle: { "font-size": "inherit", "font-weight": "inherit" },
              attrs: { for: "show_date_" + _vm.product.id },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.getTranslation(
                      "licence-configurator",
                      "set_custom_end_date"
                    )
                  ) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-5 mb-5" }, [
        _c(
          "div",
          {
            class: _vm.leaseOptions.showDatePicker === true ? "mt-4" : "d-none",
          },
          [
            _c(
              "div",
              { staticStyle: { "max-width": "280px" } },
              [
                _c("datepicker", {
                  attrs: {
                    "disabled-dates": _vm.disabledDates,
                    language: _vm.calendarLanguages[_vm.locale],
                    name: "customDate_" + _vm.product.id,
                    value: _vm.getCalendarDefaultDate(),
                    format: "yyyy-MM-dd",
                    typeable: true,
                    "input-class": "form-control",
                  },
                  on: {
                    selected: function ($event) {
                      return _vm.selectCustomDate($event)
                    },
                    input: function ($event) {
                      return _vm.selectCustomDate($event)
                    },
                    selectedDisabled: function ($event) {
                      return _vm.selectCustomDate(false)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showDateError
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.getTranslation(
                          "licence-configurator",
                          "invalid_date_selected",
                          { date: _vm.leaseOptions.customDate }
                        )
                      ) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }